import $ from "jquery";
// import Swiper JS
import Swiper, { Autoplay, Navigation, EffectFade } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Autoplay, Navigation, EffectFade]);

setTimeout(function(){
var hero_slider_obj = "";

$('.hero_slider').each(function(){
  console.log("delayed slider load");
  var $slider = $(this);
  var $slides = $slider.find('.hero_e132__slides');

  hero_slider_obj = new Swiper($slides[0], {
    slidesPerView: 1,
    autoplay: {
        enabled: true,
        delay: 2500,
    },
    speed: 500,
    loop: true,
    effect: 'fade',
    // fadeEffect: { 
    //     crossFade: true 
    // },
    breakpoints: {
        300: {
          slidesPerView: 1,
        },
        540: {
          slidesPerView: 1,
        },
        768: {
          slidesPerView: 1,
        },
        1180: {
          slidesPerView: 1,
        }
    }
  });

});



}, 1000);

